import { gql } from '@apollo/client';
import type {
    InhubSortingDimension,
    InhubSortingMetric
} from '../types';

export const GET_INHUB_SORTING_HOURLY_TREND = gql`
  query GetInhubSortingHourlyTrend($filter: InhubSortingMetricDimensionInput!) {
    getInhubSortingHourlyTrend(filter: $filter) {
      metric
      dimension
      buckets {
        hour
        bucketStart
        series {
          name
          value
        }
      }
    }
  }
`;

export interface InhubSortingMetricDimensionInput {
    hubId: number;
    rangeStart: string;
    rangeEnd: string;
    metric: InhubSortingMetric;
    dimension: InhubSortingDimension;
}

export interface InhubSortingHourlySeriesPointResp {
    name: string;
    value: number;
}

export interface InhubSortingHourlyBucketResp {
    hour: number;
    bucketStart: string;
    series: InhubSortingHourlySeriesPointResp[];
}

export interface GetInhubSortingHourlyTrendResponse {
    getInhubSortingHourlyTrend: {
        metric: InhubSortingMetric;
        dimension: InhubSortingDimension;
        buckets: InhubSortingHourlyBucketResp[];
    };
}
